import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { fadeIn } from '../../utils/motion';
import { SectionWrapper } from '../hoc'; // Correct import

// Import icons from Tech folder
import web from '../Tech/web.png';
import mobile from '../Tech/mobile.png';
import backend from '../Tech/backend.png';
import creator from '../Tech/creator.png';

// Services array for cards
const services = [
  {
    title: 'Web Developer',
    icon: web,
  },
  {
    title: 'Mobile App Developer',
    icon: mobile,
  },
  {
    title: 'Backend Developer',
    icon: backend,
  },
  {
    title: 'AI-Powered Solutions',
    icon: creator,
  },
];

// Styled components for About section
const CardsRow = styled.div`
  margin-top: 4px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  justify-items: center;
  align-items: stretch;
  width: 100%;
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 900px) {
    gap: 18px;
    margin-top: 32px;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    max-width: 700px;
  }
  @media (max-width: 600px) {
    gap: 10px;
    margin-top: 18px;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    max-width: 98vw;
  }
`;

const ServiceCardInner = styled(motion.div)`
  background: ${({ theme }) => theme.card_light};
  border-radius: 20px;
  min-height: 220px;
  max-width: 220px;
  width: 100%;
  padding: 32px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 24px rgba(23, 92, 230, 0.15);
  transition: transform 0.3s, box-shadow 0.3s;
  height: 100%;
  border: 2px solid transparent;
  background-clip: padding-box;
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 32px rgba(23, 92, 230, 0.25);
    border-color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 900px) {
    min-height: 180px;
    max-width: 180px;
    padding: 18px 10px 14px 10px;
  }
  @media (max-width: 600px) {
    min-height: 140px;
    max-width: 150px;
    padding: 12px 6px 10px 6px;
  }
`;

const ServiceIcon = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-bottom: 18px;
  transition: transform 0.3s;
  &:hover {
    transform: rotate(10deg) scale(1.1);
  }
  @media (max-width: 600px) {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
  }
`;

const ServiceTitle = styled.h3`
  color: ${({ theme }) => theme.text_primary};
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-top: 8px;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const About = () => {
  return (
    <CardsRow>
      {services.map((service, index) => (
        <ServiceCardInner
          key={service.title}
          variants={fadeIn('up', 'spring', index * 0.2, 0.75)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
        >
          <ServiceIcon src={service.icon} alt={service.title} />
          <ServiceTitle>{service.title}</ServiceTitle>
        </ServiceCardInner>
      ))}
    </CardsRow>
  );
};

export default SectionWrapper(About, 'about');